export function isPending(promise: Promise<any>) {
  const pendingFlag = Symbol('pending');
  return Promise.race([promise, Promise.resolve(pendingFlag)]).then(
    (value) => value === pendingFlag
  );
}
